import { useFetcher } from "@remix-run/react";
import type { ActionFunction } from "@remix-run/server-runtime";
import { useCallback } from "react";
import { z } from "zod";
import { toObject } from "~/kernel/form/formData";
import parseFormData from "~/kernel/form/parseFormData";
import isServer from "~/kernel/server/isServer";
import reportError from "~/kernel/error/reportError.server";
import { serializeError } from "~/kernel/error/serializeError";

export const action: ActionFunction = async ({ request }) => {
  const formDataResult = await parseFormData(request);

  if (!formDataResult.isSuccessful) {
    return null;
  }

  const data = z
    .object({
      error: z.string(),
      tag: z.string(),
    })
    .parse(toObject(formDataResult.formData));

  await reportError({
    error: data.error,
    tag: data.tag,
  });
};

export const useReportError = () => {
  const fetcher = useFetcher();
  const submit = fetcher.submit;

  return useCallback(
    ({ error, tag }: { error: unknown; tag: string }) => {
      if (isServer()) {
        return;
      }

      const formData = new FormData();
      formData.set("error", serializeError(error));
      formData.set("tag", tag);

      submit(formData, {
        action: "/report-error",
      });
    },
    [submit],
  );
};
